import { Injectable } from '@angular/core';

/**
 * Abstract AnalyticsService, to be implemented by a specific one
 */

@Injectable({
    providedIn: 'root',
})
export abstract class AnalyticsService {
    /**
     * Activate analytics
     */
    public abstract activate(): void;

    /**
     * Convert a routing url to a page path.
     * Returns undefined when url should not be sent to analytics system.
     * @param url
     * @returns string
     */
    protected getPagePath(url: string): string | undefined {
        if (
            url.startsWith('/app') ||
            url.startsWith('/admin') ||
            url.startsWith('/dedicated_admin') ||
            url.startsWith('/pages') ||
            url.startsWith('/auth')
        ) {
            return this.sanitizeUrl(url);
        }

        // Don't log others (/api, ...)
        return undefined;
    }

    private sanitizeUrl(url: string): string {
        const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
        const uuidRegex = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;

        return url.replace(emailRegex, '[EMAIL]').replace(uuidRegex, '[UUID]'); // Hide emails and uuids (GRDP recommendation)
    }
}
